var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBadge = function SvgBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 116,
    viewBox: "0 0 120 116",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 12.1576L78.5435 0.940186L86.9456 20.9184L108.544 22.7337L103.587 43.8316L120 57.9946L103.587 72.1576L108.544 93.2554L86.9456 95.0707L78.5435 115.06L60.0001 103.832L41.4565 115.06L33.0653 95.0707L11.4674 93.2554L16.4131 72.1576L0 57.9946L16.4131 43.8316L11.4674 22.7337L33.0653 20.9184L41.4565 0.940186L60.0001 12.1576Z",
    fill: "currentColor"
  })));
};
export default SvgBadge;